import Base from '../base.js';

export class Review extends Base {
    constructor(containerId, options){
        options.mode = 4;        
        super(containerId, options);
    }
}